import { app } from '../app.module'
/**
 * AccountFiltering アカウントのフィルタリングに関するService
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function AccountFiltering($rootScope, $q, AccountSetData) {
  /**
   * matchTagName タグをマッチ
   * @param  {string[]} accountTagList 対象アカウントのタグリスト
   * @param  {string[]} filterTagList 選択したタグリスト
   * @return {boolean} マッチ結果
   */
  function matchTagName(accountTagList: string[], filterTagList: string[]) {
    const notMatchFlag = filterTagList.some((filterTag) => {
      return accountTagList.indexOf(filterTag) === -1
    })

    return !notMatchFlag
  }

  /**
   * filterAccount 指定した条件で、アカウントをフィルタリングする
   * @param  {string} subCategoryName サブカテゴリ
   * @param  {string} accountGlobalFlg グローバルアカウントフラグ
   * @param  {array} sortAccounts フィルタリングに適合しているアカウント一覧
   * @param  {array} removedAccounts
   * @return {array} フィルタリングしたアカウント一覧
   */
  function filterAccount(
    subCategoryName: string,
    accountGlobalFlg: string,
    sortAccounts: string[],
    removedAccounts: string[]
  ) {
    const deferred = $q.defer()
    let allAccounts

    // 適合アカウントと除外されたアカウントが両方ある場合は結合してフィルタリングの対象とする
    if (
      sortAccounts !== null &&
      sortAccounts !== undefined &&
      removedAccounts !== null &&
      removedAccounts !== undefined
    ) {
      allAccounts = sortAccounts.concat(removedAccounts)
      // 除外されたアカウントが存在しない場合は、適合アカウントのみをフィルタリングの対象とする
    } else if (removedAccounts === null || removedAccounts === undefined) {
      allAccounts = sortAccounts
      // 適合アカウントが存在しない場合は、除外されたアカウントのみをフィルタリングの対象とする
    } else if (sortAccounts === null || sortAccounts === undefined) {
      allAccounts = removedAccounts
    }
    const matchedAccounts: {
      key?: string
    }[] = []
    const unMatchedAccounts: {
      key?: string
    }[] = []
    // タグをフィルターしないアカウント一覧
    this.sortAccountsWithoutFilterTag = []
    // 全てのアカウントに対して、フィルター条件に適合するかチェックする
    allAccounts.forEach((account) => {
      // 適合フラグを立てる
      let isMatched = true

      // 指定したフォロワー数の範囲から外れた場合、適合フラグを外す
      if ($rootScope.followerFilter !== null) {
        const followerMatch = $rootScope.followerFilter.some((elem) => {
          if (account.hiddenSubscribersFlg === 1) {
            return elem === '非公開'
          }
          return account.followersRange === parseInt(elem.split('-')[0], 10)
        })

        if (followerMatch !== true) {
          isMatched = false
        }
      }
      // アカウント名でフィルタリング
      // アカウント名と検索するキーワードが違う場合、falseをリターン
      let screenNameIsMatch = false
      let userNameIsMatch = false
      if ($rootScope.messageFilter) {
        if (account.screenName !== null) {
          screenNameIsMatch =
            account.screenName.match(
              new RegExp($rootScope.messageFilter.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i')
            ) !== null
        }
        if (account.username !== null) {
          userNameIsMatch = account.username === $rootScope.messageFilter
        }
        if (screenNameIsMatch === false && userNameIsMatch === false) {
          isMatched = false
        }
      }

      // サブカテゴリでフィルタリング
      if (
        subCategoryName !== null &&
        subCategoryName !== '指定しない' &&
        account.subCategoryName !== subCategoryName
      ) {
        isMatched = false
      }

      // グローバルアカウントでフィルタリング
      if (accountGlobalFlg !== null && account.internationalFlg !== accountGlobalFlg) {
        isMatched = false
      }

      if (isMatched === true) {
        this.sortAccountsWithoutFilterTag.push(account)
      }

      // アカウントタグでフィルタリング
      if ($rootScope.accountTagFilter && $rootScope.accountTagFilter.length > 0) {
        let accountTagNames = []
        if (account.tags.globalTagNames !== null) {
          accountTagNames = accountTagNames.concat(account.tags.globalTagNames.split(','))
        }

        if (account.tags.groupTagNames !== null) {
          accountTagNames = accountTagNames.concat(account.tags.groupTagNames.split(','))
        }

        if (account.tags.userTagNames !== null) {
          accountTagNames = accountTagNames.concat(account.tags.userTagNames.split(','))
        }
        isMatched = isMatched && matchTagName(accountTagNames, $rootScope.accountTagFilter)
      }

      // 適合フラグがtrueの場合は、適合アカウント一覧の配列へプッシュする
      if (isMatched === true) {
        matchedAccounts.push(account)
      } else {
        // 適合フラグがfalseの場合は、不適合アカウント一覧の配列へプッシュする
        unMatchedAccounts.push(account)
      }
    })

    const filterdAccounts: {
      sortAccounts: {}
      removedAccounts: {}
    } = {
      // フィルタリングに適合した投稿一覧をセット
      sortAccounts: matchedAccounts,
      // フィルタリングに不適合の投稿一覧をセット
      removedAccounts: unMatchedAccounts,
    }

    this.sortAccounts = matchedAccounts

    deferred.resolve(filterdAccounts)
    // promiseとしてリターンする
    return deferred.promise
  }

  /**
   * getTagList アカウントタグリストを取得
   * @returns {Object} アカウントタグリスト
   */
  function getTagList() {
    const allAccounts = this.sortAccountsWithoutFilterTag
    // フィルタリスト
    const postFilterLists = []

    // フィルタリストがある場合、セット
    if (AccountSetData.accountTags.length > 0) {
      AccountSetData.accountTags.forEach(function (filter) {
        const count = allAccounts.filter(function (account) {
          const globalTagNames = account.tags.globalTagNames
          const groupTagNames = account.tags.groupTagNames
          const userTagNames = account.tags.userTagNames
          const isExistTag =
            (globalTagNames !== null && globalTagNames.split(',').indexOf(filter) > -1) ||
            (groupTagNames !== null && groupTagNames.split(',').indexOf(filter) > -1) ||
            (userTagNames !== null && userTagNames.split(',').indexOf(filter) > -1)

          if (isExistTag === true) {
            return true
          } else {
            return false
          }
        }).length

        // カウントが0より大きい場合、フィルタリストに追加
        if (count > 0) {
          postFilterLists.push({
            value: filter,
            count: count,
          })
        }
      })

      // 件数をソート
      postFilterLists.sort((a, b) => {
        return b.count - a.count
      })
    }

    return postFilterLists
  }

  return {
    filterAccount: filterAccount,
    getTagList: getTagList,
    sortAccounts: [],
  }
}

/**
 * AccountSetData アカウント一覧のセットに関するService
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function AccountSetData(Restangular, $q, CommonService) {
  /**
   * setNumberData numberのチェック(nullの場合、0をリターン)
   * @param {number} checkData チェックデータ
   * @param {number} returnData リターンデータ
   * @return {number} 結果
   */
  function setNumberData(checkData: number, returnData: number) {
    if (returnData === null) {
      returnData = checkData
    }
    return checkData !== null && checkData !== 0 ? returnData : 0
  }

  /**
   * createArrayFromString ストリングを配列に変換
   * @param {string} stringValue ストリング
   * @return {array} 結果
   */
  function createArrayFromString(stringValue) {
    const stringSplit = stringValue.split(',')
    const arrayValue = []

    stringSplit.forEach((string) => {
      // 複製バリューを格納しない
      if (string !== '' && arrayValue.indexOf(string) === -1) {
        arrayValue.push(string)
      }
    })
    return arrayValue
  }

  /**
   * setAccounts アカウントのデータをセット
   * @param {string} snsType SNSタイプ
   * @param {Object} accounts アカウント一覧
   * @return {array} アカウント一覧
   */
  function setAccounts(snsType: string, accounts) {
    const accountsData: {}[] = []
    let allAccountTags: {}[] = []

    // データがある場合、セット
    if (accounts !== null) {
      accounts.forEach((account) => {
        // フォロワー
        const followers = setNumberData(account.followers, null)
        // フォロワー増減率
        const followersStart = setNumberData(account.followersStart, null)
        const followersEnd = setNumberData(account.followersEnd, null)
        let followersUpdownRate = null
        if (followersStart !== null && followersStart > 0) {
          followersUpdownRate = Number(
            ((account.followersEnd / followersStart - 1) * 100).toFixed(2)
          )
        }
        // 投稿数
        const posts = setNumberData(account.posts, null)
        // いいね
        const likes = setNumberData(account.likes, null)

        // 反応数
        const engagements = setNumberData(account.engagements, null)
        // 全投稿のフォロワー数
        const followerPostTotal = setNumberData(account.followerPostTotal, null)
        // 反応率
        const engagementRate = Number(
          setNumberData(followerPostTotal, (engagements / followerPostTotal) * 100).toFixed(2)
        )

        // アカウントのデータをセット
        const accountObject = {
          screenName: account.screenName,
          username: account.username !== undefined ? account.username : null,
          accountId: account.accountId,
          pictureUrl: account.pictureUrl,
          internationalFlg: 0,
          brandName: account.brandName,
          categoryName: account.brandCategoryName,
          subCategoryName: account.brandSubCategoryName,
          followers: followers,
          followersStart: followersStart,
          followersEnd: followersEnd,
          followersUpdownRate: followersUpdownRate,
          followersRange: account.followersRange,
          memoCount: account.memoCount,
          dataFlg: account.dataFlg,
          hiddenSubscribersFlg: 0,
          likes: likes,
          dislikes: null,
          durations: null,
          views: null,
          comments: null,
          shares: null,
          retweets: null,
          impressions: null,
          replies: null,
          quotes: null,
          plays: null,
          collects: null,
          engagements: engagements,
          engagementRate: engagementRate,
          posts: posts,
          accountUrl: CommonService.setAccountUrl(snsType, account.accountId, account.username),
          tags: {
            globalTagIds: account.globalTagIds,
            globalTagNames: account.globalTagNames,
            groupTagIds: account.groupTagIds,
            groupTagNames: account.groupTagNames,
            userTagIds: account.userTagIds,
            userTagNames: account.userTagNames,
          },
        }

        switch (snsType) {
          case 'facebook':
            accountObject.internationalFlg = account.internationalFlg
            accountObject.comments = setNumberData(account.comments, null)
            accountObject.shares = setNumberData(account.shares, null)
            break

          case 'twitter':
            accountObject.retweets = setNumberData(account.retweets, null)
            accountObject.impressions = setNumberData(account.impressions, null)
            accountObject.quotes = setNumberData(account.quotes, null)
            accountObject.replies = setNumberData(account.replies, null)
            break

          case 'instagram':
            accountObject.comments = setNumberData(account.comments, null)
            break

          case 'youtube':
            accountObject.dislikes = setNumberData(account.dislikes, null)
            accountObject.comments = setNumberData(account.comments, null)
            accountObject.durations = setNumberData(account.durations, null)
            accountObject.views = setNumberData(account.views, null)
            accountObject.hiddenSubscribersFlg = account.hiddenSubscribersFlg
            break

          case 'line':
            accountObject.comments = setNumberData(account.comments, null)
            accountObject.shares = setNumberData(account.shares, null)
            break

          case 'tiktok':
            accountObject.comments = setNumberData(account.comments, null)
            accountObject.shares = setNumberData(account.shares, null)
            accountObject.plays = setNumberData(account.plays, null)
            accountObject.collects = setNumberData(account.collects, null)
            accountObject.engagementRate = Number(
              setNumberData(account.plays, (engagements / account.plays) * 100).toFixed(2)
            )
            break
        }

        // アカウントタグがある場合、セット
        let accountTagName = ''
        let accountTagArray = []

        if (account.globalTagNames !== null) {
          accountTagName = account.globalTagNames
        }

        if (account.groupTagNames !== null) {
          accountTagName = accountTagName + ',' + account.groupTagNames
        }

        if (account.userTagNames !== null) {
          accountTagName = accountTagName + ',' + account.userTagNames
        }

        if (accountTagName !== '') {
          accountTagArray = createArrayFromString(accountTagName)
          allAccountTags = allAccountTags.concat(
            accountTagArray.filter(function (tag) {
              return allAccountTags.indexOf(tag) < 0
            })
          )
        }

        // アカウント一覧にアカウントのデータを追加
        accountsData.push(accountObject)
      })
    }

    // アカウントタグ一覧をセット
    this.accountTags = allAccountTags

    return accountsData
  }

  /**
   * getAccounts 指定されたSNSのアカウント一覧を取得
   * @param {object} getOptions 取得オプション(取得対象月、取得対象業種)
   * @return {Object} アカウント一覧
   */
  function getAccounts(
    groupId: number,
    userId: number,
    snsType: string,
    getOptions: {
      startEndDate: {
        startDate: number
        endDate: number
      }
      categoryName: string
      isPro: boolean
    }
  ) {
    const deferred = $q.defer()
    let getUrl = `/account/getAccounts?groupId=${groupId}&userId=${userId}`

    getUrl += `&startDate=${getOptions.startEndDate.startDate}&endDate=${getOptions.startEndDate.endDate}&snsType=${snsType}&is_pro=${getOptions.isPro}`

    // 業種カテゴリでフィルタリングする場合、パラメーターに業種カテゴリを追加
    if (getOptions.categoryName !== null) {
      getUrl += `&categoryName=${getOptions.categoryName}`
    }

    // 選択した期間でアカウント一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((accountDatas) => {
        deferred.resolve(accountDatas[0].data)
      })

    return deferred.promise
  }

  /**
   * orderBy ソートの処理
   * @param {array} accounts アカウント一覧
   * @param {string} order ソート対象
   * @param {boolean} dataPerPost 1投稿にあたりのフラグ
   * @return {Object} アカウント一覧
   */
  function orderBy(accounts, order, dataPerPost) {
    let reverse = true
    const orderArray = order.split('-')
    const dataPerPostArray = [
      'likes',
      'comments',
      'retweets',
      'shares',
      'engagements',
      'dislikes',
      'durations',
      'views',
      'plays',
      'collects',
    ]
    let aSortData: number
    let bSortData: number

    // リバースの場合
    if (orderArray.length > 1) {
      reverse = false
      order = orderArray[1]
    }
    // ソートを行う
    accounts.sort(function (a, b) {
      // 1投稿あたりの平均をソートする場合
      if (dataPerPostArray.indexOf(order) > -1 && dataPerPost === true) {
        // 投稿数が0より多い場合、1投稿あたりの平均をセット
        if (a.posts) {
          aSortData = a[order] / a.posts
        } else {
          aSortData = 0
        }

        // 投稿数が0より多い場合、1投稿あたりの平均をセット
        if (b.posts) {
          bSortData = b[order] / b.posts
        } else {
          bSortData = 0
        }
      } else {
        aSortData = a[order]
        bSortData = b[order]
      }
      if (aSortData === null) {
        return -1
      }
      if (bSortData === null) {
        return 1
      }
      return aSortData > bSortData ? 1 : -1
    })

    // リバース
    if (reverse) {
      accounts.reverse()
    }

    return accounts
  }

  return {
    setAccounts: setAccounts,
    getAccounts: getAccounts,
    orderBy: orderBy,
    accountTags: [],
  }
}

/**
 * AccountService 投稿表示機能関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} AccountFiltering アカウントのフィルタリングに関するService
 * @param {Function} AccountSetData アカウント一覧のセットに関するService
 * @return {Object} サービスのオブジェクト
 */
function AccountService(AccountFiltering, AccountSetData) {
  return {
    // アカウントのフィルタリングに関するService
    Filtering: AccountFiltering,
    Account: AccountSetData,
  }
}

// アカウント一覧表示機能用のサービスを定義
app
  .factory('AccountService', AccountService)
  .factory('AccountFiltering', AccountFiltering)
  .factory('AccountSetData', AccountSetData)
